import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { usePicksContext } from '../../contexts/Picks/PicksContext';
import { iconModality, shortNameModality } from '../../helpers/utilsUi';
import Modal from '../Modal/modal';
import Button from '../ui/button';

interface iProps {
	modality: any[];
	loading: boolean;
	filters: any;
	setFilters: (filters: any) => void;
}

export const FilterModality = ({
	modality,
	loading,
	filters,
	setFilters,
}: iProps) => {
	const { ClearPicks, picks } = usePicksContext();
	const [openAlert, setOpenAlert] = useState(false);
	const [changed, setchanged] = useState('');

	const handleChange = (name: string) => {
		if (picks.length > 0 && name !== filters.modality) {
			setOpenAlert(true);
			setchanged(name);
			return;
		}
		setFilters((prev: any) => ({
			...prev,
			modality: name,
		}));
	};

	const modalSuccess = () => {
		return (
			<Modal
				id="alert-modality-change"
				open={openAlert}
				onClose={() => {
					setOpenAlert(!openAlert);
				}}
			>
				<div className="flex flex-col gap-6 items-center">
					<p className="text-2xl font-bold text-left text-custom-gray2 font-bahnschrift">
						Atenção!
					</p>
					<p className="w-80 text-base text-center text-custom-gray2 font-bahnschrift">
						Quer mudar de esporte? Sem problema! Só vale lembrar que
						você vai precisar selecionar seus picks novamente.
					</p>

					<div className="flex flex-row justify-between gap-2 w-full">
						<Button
							onClick={() => {
								setOpenAlert(false);
							}}
							variant="help"
							textCustom="text-primary text-sm font-semibold"
							className="w-1/2 py-2 px-3.5"
						>
							Fechar
						</Button>
						<Button
							onClick={() => {
								setFilters((prev: any) => ({
									...prev,
									modality: changed,
								}));
								ClearPicks();
								setOpenAlert(false);
							}}
							className="w-1/2 h-12"
						>
							Entendi
						</Button>
					</div>
				</div>
			</Modal>
		);
	};

	return (
		<div className="flex px-3 flex-row gap-3">
			{loading ? (
				<div>
					<Skeleton className="w-full h-12 rounded-lg" />
				</div>
			) : (
				modality.map((item) => (
					<div
						className="flex flex-col text-center items-center relative cursor-pointer "
						onClick={() => handleChange(item.name)}
						key={item.id}
					>
						<div
							className={
								'w-12 h-12 text-white font-bahnschrift text-xs bg-primary items-center justify-center flex rounded-full border-2 ' +
								(item.name === filters.modality
									? ' border-custom-yellow'
									: '')
							}
						>
							{iconModality(item.name)}
						</div>
						<span className="font-bahnschrift text-center text-xs">
							{shortNameModality(item.name)}
						</span>
					</div>
				))
			)}
			{modalSuccess()}
		</div>
	);
};
